import { __assign } from "tslib";
import React, { useEffect, useState } from "react";
import { StyledTable, StyledTh } from "./styles";
import { TiArrowSortedDown } from "react-icons/ti";
export var FilterTable = function (_a) {
    var header = _a.header, clickableHeaders = _a.clickableHeaders, defaultFilter = _a.defaultFilter, children = _a.children, alwaysLeft = _a.alwaysLeft, tableStyles = _a.tableStyles, thStyles = _a.thStyles, tdStyles = _a.tdStyles, onChangeFilter = _a.onChangeFilter;
    var _b = useState(defaultFilter || {
        id: 0,
        type: "desc"
    }), filterBy = _b[0], setFilterBy = _b[1];
    var handleChangeFilter = function (idx) {
        if (idx === filterBy.id) {
            if (filterBy.type === "desc") {
                setFilterBy(__assign(__assign({}, filterBy), { type: "asc" }));
            }
            else {
                setFilterBy(__assign(__assign({}, filterBy), { type: "desc" }));
            }
        }
        else {
            setFilterBy({ id: idx, type: "desc" });
        }
    };
    var getAlignment = function (idx) {
        if (alwaysLeft) {
            return "left";
        }
        if (idx === 0) {
            return "left";
        }
        else if (idx === header.length - 1) {
            return "right";
        }
        else {
            return "center";
        }
    };
    var getFlexAlignment = function (idx) {
        if (alwaysLeft) {
            return "flex-start";
        }
        if (idx === 0) {
            return "flex-start";
        }
        else if (idx === header.length - 1) {
            return "flex-end";
        }
        else {
            return "center";
        }
    };
    useEffect(function () {
        if (onChangeFilter) {
            onChangeFilter(filterBy);
        }
    }, [filterBy]);
    return (React.createElement(StyledTable, { style: tableStyles, thStyles: thStyles, tdStyles: tdStyles, alwaysLeft: alwaysLeft },
        React.createElement("thead", null,
            React.createElement("tr", null, header.map(function (item, index) {
                var clickable = clickableHeaders && clickableHeaders.includes(index);
                return (React.createElement(StyledTh, { key: index, isSelected: filterBy.id === index, clickable: clickable, onClick: function () {
                        if (clickable) {
                            handleChangeFilter(index);
                        }
                    }, style: {
                        textAlign: getAlignment(index)
                    } },
                    React.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: getFlexAlignment(index),
                            gap: 2
                        } },
                        React.createElement("span", { style: {
                                color: filterBy.id === index ? "#000000" : "#6c6c6c"
                            } }, item),
                        clickableHeaders && clickableHeaders.includes(index) && (React.createElement(TiArrowSortedDown, { size: 20, style: {
                                minWidth: 20,
                                transition: "all 0.2s",
                                opacity: filterBy.id === index ? 1 : 0,
                                transform: filterBy.type === "asc"
                                    ? "rotateX(180deg)"
                                    : "rotateX(0deg)"
                            } })))));
            }))),
        children));
};
//# sourceMappingURL=index.js.map